import React, { useContext, useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { dynamoProductQueries } from '../../../../graphql/queries';
import HandDetails from './HandDetails.js';
import NotFoundMessage from '../../../../Components/Store/NotFoundMessage.js';
import LoadingScreen from '../../../../Components/LoadingScreen.js';
import {
  getNextHand,
  formatPathToHandPlay
} from '../../../../helpers/hand.js';
import {
  HandContext,
  UserContext
} from '../../../../Context';
import { useHandAndParentQuery } from '../../../../Hooks';

export default function SetHandDetails () {
  let {
    setId,
    handId,
    linkId,
    language,
    embed
  } = useParams();

  handId = parseInt(handId);
  setId = parseInt(setId);

  const navigate = useNavigate();

  const { user } = useContext(UserContext);

  const { init: initHandContext } = useContext(HandContext);

  const productQuery = (linkId ? 'DynamoProductByLinkId' : 'DynamoProductById');

  const queryResponse = useHandAndParentQuery({
    handId,
    parentId: linkId || setId,
    language,
    parentQuery: dynamoProductQueries[productQuery]
  });

  // useHandAndParentQuery only knows the queries resolved, not that the ids matched —
  // the inner hand/parent are null for a bad deep link, so extract and guard them here.
  const set = queryResponse && queryResponse.parentData && (linkId ? queryResponse.parentData.dynamoProductByLinkId : queryResponse.parentData.dynamoProductById);
  const hand = queryResponse && queryResponse.handData && queryResponse.handData.handById;

  const getNextHandUrl = useCallback((set) => {
    const nextHand = getNextHand(handId, set.hands);
    if (nextHand) {
      return formatPathToHandPlay(null, set, nextHand);
    }
    return undefined;
  }, [handId]);

  useEffect(() => {
    if (set && hand) {
      initHandContext({
        hand,
        parent: set,
        nextHandUrl: getNextHandUrl(set),
        currentUser: user,
        linkId,
        isEmbed: embed
      });
    }
  }, [set, hand, initHandContext, getNextHandUrl, user, embed, linkId]);

  if (!queryResponse) {
    return <LoadingScreen />;
  }

  if (!set || !hand) {
    return (
      <NotFoundMessage
        message='hand-not-found'
        actionLabel='browse-products'
        onAction={() => navigate('/products')}
      />
    );
  }

  return (
    <HandDetails />
  );
}
